module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./player.es.js"));
	}, "player.es");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./node_modules/@vimeo/player/dist/player.es.js
// module id = 246
// module chunks = 3